import { createGoalModel } from '@akin-home/goals';
import { z } from 'zod';
import { createGoalMutation } from '../../api';
import { goalModelToCreateGraphql } from '../../functions';
import { CreateGoalCommand } from './schema';

const Params = z.object({
  user_id: z.string(),
  habitatID: z.string(),
  data: CreateGoalCommand.shape.data,
});

type Params = z.infer<typeof Params>;

type ConstructorParams = {
  callback(result: Result, params: Params): void;
};

type Result = { success: true } | { success: false };

export function constructCreateGoalCommand({ callback }: ConstructorParams) {
  return async (params: Params) => {
    const { goal, error } = createGoalCommand(params);

    if (error) {
      callback({ success: false }, params);
      return;
    }

    try {
      await createGoalMutation({
        input: goalModelToCreateGraphql(goal),
      });

      callback({ success: true }, params);
    } catch (ex) {
      callback({ success: false }, params);
    }
  };
}

export const createGoalCommand = (params: Params) => {
  const result = Params.safeParse(params);

  if (!result.success) {
    return { error: result.error };
  }

  const { data } = result;

  const {
    user_id,
    habitatID,
    data: { success_message, ...goal_data },
  } = data;

  return {
    success_message,
    goal: createGoalModel({
      ...goal_data,
      habitatID: habitatID,
      participant_ids: [user_id],
    }),
  };
};
